export const environment = {
  production: true,
  buildId: '2489619387617271',
  configFile: 'config.json',
};
